import { type Actions, ActionType } from './unit-groups.actions';
import { initialState, type State, unitGroupsAdapter } from './unit-groups.state';

export function unitGroupsReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.FETCH_UNIT_GROUPS:
            return { ...state, isPending: true, error: null };

        case ActionType.FETCH_UNIT_GROUPS_SUCCEEDED:
            return unitGroupsAdapter.setAll(action.payload.unitGroups, { ...state, isLoaded: true, isPending: false, error: null });

        case ActionType.FETCH_UNIT_GROUPS_FAILED:
            return { ...state, isPending: false, error: action.payload.error };

        default:
            return state;
    }
}
